import { TYPE_REPORT } from './TypeReport'

export const urls = {
	users: {
		index: '/user/:id',
		sendToken: '/user/:id/resend_api_token',
	},
	orders: {
		products: '/sber_mq/product',
		products_recommendations: '/sber_mq/product/recommendation',
		show_businessapp: '/sber_mq/product/businessapp',
		recommendations: '/sber_mq/recommendation',
		merchant: '/merchant',
		orders: '/sber_mq/order',
		comment: '/sber_mq/order/:id/comment',
		contact_details: '/sber_mq/order/:id/contact_details',
		resend_msp_sms: '/sber_mq/order/:id/resend_msp_sms',
		resend_premium_sms: '/sber_mq/order/:id/resend_premium_sms',
		resend_premium_email: '/sber_mq/order/:id/resend_premium_email',
		get_integration: 'sber_mq/order/:id/integration_action',
		regions: '/sber_mq/region',
		merchantBranches: '/sber_mq/merchant_branch',
		block: '/sber_mq/block',
		blocking_rule: '/sber_mq/blocking_rule',
		product_group: '/sber_mq/product_group',
		unBlockRequest: '/sber_mq/unblock_request',
		backToChecking: '/sber_mq/unblock_request/:id/back_to_checking',
		sendStatuses: '/sber_mq/product_order_relation/mass_assign_payment_statuses',
		orderStatuses: 'sber_mq/order/statuses',
		mass_assign_products: '/sber_mq/partner_product_relation/mass_assign_products',
		reports: '/sber_mq/reports/orders',
		small_reports: '/sber_mq/reports/small_orders',
		dzo_reports: '/sber_mq/reports/dzo_orders',
		unblock_requests_reports: '/sber_mq/reports/unblock_requests',
		crmStatuses: '/sber_mq/crm_status',
		unblockRequestStatuses: 'sber_mq/unblock_request/statuses',
		productOrderStatuses: '/sber_mq/product_order_status',
		externalForm: 'sber_mq/external_form',
		createInstruction: 'sber_mq/external_form/create_instruction',
		instructionUrl: 'sber_mq/external_form/instruction',
		product_order_status: '/sber_mq/product_order_status/mass_assign_statuses',
		integrationChannels: '/sber_mq/integration_channel',
		integrationCodes: '/sber_mq/product/integration_codes',
		report_merchant_branches: '/sber_mq/reports/merchant_branches',
		integrationOrder: 'sber_mq/order',
		productGroups: 'sber_mq/product_group',
		total_orders: 'sber_mq/order/total_entries',
		crm_status: '/sber_mq/product_order_relation/mass_assign_crm_statuses',
		not_signed: '/sber_mq/order/not_signed',
		create_reserve_account: 'sber_mq/order/:id/reserve_accounts',
		possibility_to_reserve_an_account: 'sber_mq/order/possibility_to_reserve_an_account',
		force_send: '/sber_mq/order/:id/force_send',
		show_reserve_account: '/sber_mq/order/reserve_accounts/:id',
		attachment: '/sber_mq/businessapp/attachments/:id/:filename',
		businessapps: '/sber_mq/businessapp',
		otkritie_bank_cities: '/sber_mq/order/otkritie_bank_cities',
		pao_sberbank: '/sber_mq/product_order_relation/cancel_mass_assign',
		dzo: '/sber_mq/product_order_status/cancel_mass_assign',
		crm_statuses: '/sber_mq/product_order_relation/cancel_mass_assign_crm',
		blacklist_main: '/sber_mq/black_list',
		report_external_forms: '/sber_mq/reports/external_forms',
		recognize_passport: '/recognize_passport',
		cities_regions: '/sber_mq/reserve_accounts/cities',
		slots: '/sber_mq/reserve_accounts/slots',
		appointment: '/sber_mq/reserve_accounts/create_appointment',
		cm_status: './sber_mq/reserve_accounts/cm_status',
	},
	sberGeoUnits: {
		index: '/sber_geo_units',
		addresses: '/sber_geo_units/addresses',
	},
	channels: {
		index: '/channel',
		categories: '/channel/categories',
	},
	referenceBook: {
		territorialBank: '/territorial_bank',
		gosb: '/gosbs',
		sectors: '/sectors',
		channelStructure: '/user/channel_structure',
		channelExcel: '/reports/users_channel_structure',
		specialOffers: '/special_offers',
	},
	root: {
		dashboard: {
			widget: '/dashboard/data/widget',
			data: '/dashboard/data',
			news: '/dashboard/news',
			stats: 'dashboard/news/stats',
			document: 'dashboard/document',
			availableProducts: '/dashboard/data/available_products',
		},
		notifications: '/notifications',
	},
	common: {
		partner_payment: '/partner/payment',
		bik: '/partner/suggest_bank_names',
		catalogs: {
			region: '/sber_mq/region',
			regions: '/sber_mq/region',
			mq_city: '/sber_mq/city',
			user: '/user',
		},
		setting: '/setting',
		email: {
			email_confirmation: 'email_confirmation',
		},
	},
	customer_identification: {
		index: 'customer_identification',
	},
	rbidos_request: {
		index: 'rbidos/lead',
	},
	rbidos_lead: {
		index: 'lead',
		activate: 'lead/activate',
		complete: 'lead/complete',
		refresh_sms: 'lead/refresh_sms',
		validate: 'lead/validate',
		archivate: 'lead/archivate',
		reports: 'reports/leads',
		user_info_after_sber_id: '/lead/:id/sberid_user_info',
		notary_file: '/lead/notary_file/:id/:file_type',
		mass_update: '/mass_update/leads_with_violation',
		mass_update_file: '/lead/change_status_from_file',
	},
	rbidos_access: {
		infotecsLogin: 'user/infotecs_login',
		base: '/infotecs_requests',
		logs: '/infotecs_requests/:id/logs',
		sign: '/infotecs_requests/:infotecs_request_id/documents/:id/sign',
		attachment: '/infotecs_requests/:request_id/documents/:id/file/attachment',
		attachment_signature: '/infotecs_requests/:request_id/documents/:id/file/signature',
		send_signature: '/infotecs_requests/:id/send_signature',
		base_agent: '/infotecs_agents',
		identification_points: '/identification_points',
	},
	advertisement: {
		index: '/ord/organizations',
		contracts: '/ord/contracts',
		creatives: '/ord/creatives',
		invoices: '/ord/invoices',
		calculate: '/ord/invoices/calculate',
		autogenerate: '/ord/invoices/autogenerate',
		dicts: '/ord/dicts',
		platforms: '/ord/platforms',
		logs: '/ord/:tab/:id/support_info',
		toggle_active: '/ord/creatives/:id/toggle_active',
		active_platform: '/ord/platforms/:id/toggle_active',
		media_files: '/ord/creatives/media_files/:id',
		statuses: '/ord/:tab/statuses',
		logs_adriver: '/ord/:tab/:id/adriver_logs',
	},

	knowledge: {
		project: '/knowledge/project',
		article: '/knowledge/article/',
		access: '/knowledge/user_article_rule/',
		tag: '/knowledge/tag/',
		tag_random: '/knowledge/tag/random',
		attachment: '/knowledge/attachment/',
		base: '/knowledge',
		video: '/knowledge/project/:projectSlug/article/:articleSlug',
		base_video_url: 'https://uni-storage.dev.dasreda.ru/v1',
		base_video_url_prod: 'https://uni-storage.dasreda.ru/v1',
		video_url: '/cdn/file/hls?s3FileName=:s3FileName',
	},
	som: {
		sms: '/sms',
		sms_rule: '/sms_rule/',
		sms_sender: '/setting/sms_sender',
		sms_statistic: '/sms/statistic',
	},
	interface_element: {
		index: '/interface_element',
		available: '/interface_element/available',
		role_interface: '/role_interface_element_available',
	},
	pp: {
		ast: {
			load_plan_info: '/ast_partner_requests/load_plan_info',
		},
		partner: {
			info: '/partner/:id/:type',
			show: '/partner/:id',
			products: '/partner/:id/products',
			send_xml_to_crm: '/partner/:id/send_xml_to_crm',
			status_partner: '/partner/:partner_id/set_status/:status',
			partner_blocking: '/partner/:id/deactivate_partner',
			liquidate: '/partner/:id/liquidate',
			revert_liquidation: '/partner/:id/revert_to_previous_state',
		},
		mass_use_merchant: {
			create: '/mass_use_merchant_create',
			delete: '/mass_use_merchant_destroy',
		},
		massUpdateCurator: {
			updateCurator: '/mass_update/partner',
		},
		contractsRegistry: {
			contracts: '/partner_contract',
			contractNumbers: '/partner_contracts/contract_numbers',
			massUpdate: '/mass_update/partner_contracts',
			contactFaces: '/partner/:partner_id/available_contact_faces',
			createAstPartnerRequests: '/ast_partner_requests',
			notify_contract_limit_remainder: '/partner/:id/notify_contract_limit_remainder',
			download_limit: '/partner_contract/:id/limit_notification_file',
			manager: '/filters/managers',
			city: '/sber_mq/city',
		},
		matrix_role: {
			function: '/function',
			role: '/role',
		},
	},
	coliseum: {
		call: '/call_easy/call_requests',
		block: '/call_easy/blocks',
		blacklist: '/call_easy/black_lists',
		massload: '/call_easy/black_lists/mass_load',
		callstatus: '/call_easy/call_requests/call_statuses',
		status: '/call_easy/call_requests/statuses',
		source: '/call_easy/black_lists/sources',
		events_setting: '/call_easy/reports/events_setting',
		partner_setting: '/call_easy/partner_settings',
		potentialClientStatus: '/call_easy/call_requests/potential_client_statuses',
	},
	dadata: {
		address: 'dadata/suggest_address',
		fias: 'dadata/suggest_fias',
		fias_with_oktmo: 'dadata/suggest_fias_with_oktmo',
		short_name: 'dadata/suggest_short_name',
	},
	cabinet: {
		rbidosRequest: 'rbidos_request',
		infotecsLogin: 'user/infotecs_login',
		okveds: 'rbidos_request/okveds',
		paymentCallback: 'rbidos_request/payment_callback',
		inn: 'rbidos_request/inn',
		okved_packages: '/okved_package',
		rbidosCustomer: 'customer_identification',
		infotecs_search: 'customer_identification/infotecs_search',
		suggest_fms_unit: 'dadata/suggest_fms_unit',
		remote_docs_upload: '/rbidos_remote_doc_uploads',
		remote_docs_info: '/rbidos_remote_doc_uploads/:token',
		client_remote_docs_upload: '/rbidos_request/:id/remote_document/:doc_type',
		client_remote_docs_delete: '/rbidos_request/:request_id/remote_document/:id',
		recommendations: '/sber_mq/product/recommendation',
		products: '/sber_mq/product',
		divisions: '/rbidos_request/divisions',
		regions: '/rbidos_request/regions',
		tariffs: '/rbidos_request/tariffs',
		businessapp: '/sber_mq/businessapp',
		otkritie_bank_cities: '/sber_mq/order/otkritie_bank_cities',
		download_all_documents: '/rbidos_request/:id/generated_docs_archive',
		mcc_code: '/mcc_code',
		mcc_group: '/mcc_group',
		patent: {
			index: '/rbidos_request/:id/rbidos_patent_applications',
			disable_patent: '/rbidos_request/:id/disable_patent',
			transport:
				'/rbidos_patent_applications/:rbidos_patent_applications_id/rbidos_patent_transports',
			realty: '/rbidos_patent_applications/:rbidos_patent_applications_id/rbidos_patent_realties',
		},
		dicts: {
			activity_codes: 'dicts/activity_codes',
			object_code_types: 'dicts/object_code_types',
			transport_type_codes: 'dicts/transport_type_codes',
			types_of_object_attributes: 'dicts/types_of_object_attributes',
		},
		cities_regions: '/rbidos_request/:id/cities',
		slots: '/rbidos_request/:id/slots',
		appointment: '/rbidos_request/:id/create_appointment',
		cm_status: '/rbidos_request/:id/cm_status',
	},
	company: {
		index: '/company',
		address: '/partner',
	},
	acts: {
		file: '/nepal/acts/:act_id/file',
		index: '/nepal/acts',
		show: '/nepal/acts/:id',
		partners_sign: '/nepal/acts/partners_sign',
		ds_sign: '/nepal/acts/:id/ds_sign',
		upload: '/nepal/acts/upload',
		upload_reestr: '/nepal/acts/build_from_file',
		upload_promotion_reestr: 'nepal/acts/build_promotion_from_file',
		upload_paids: '/nepal/acts/upload_paids',
		cancel_paids: '/nepal/acts/cancel_paids',
		create_sms_code: '/nepal/sms_codes',
		statuses: '/nepal/acts/statuses',
		cancel: '/nepal/acts/cancel',
		cancel_kinds: '/nepal/acts/cancel_kinds',
		delete: '/nepal/acts/delete',
		restore: '/nepal/acts/restore',
		set_status: '/nepal/acts/:act_id/set_status',
		clear_sms: '/nepal/sms_codes/:partner_id/clear',
		unblock: '/nepal/acts/:act_id/unblock',
		send_act_protocol: '/nepal/acts/:act_id/protocol',
		refund: '/nepal/acts/refund',
		collection_archive: '/nepal/acts/collection_archive',
		archive: '/nepal/acts/:act_id/archive',
		partner_can_sign: '/nepal/acts/partner_can_sign',
		send_refund_emails: '/nepal/acts/send_refund_emails',
		act_counter: '/nepal/partners/act_counter/',
		act_counter_filter: '/nepal/partners/act_counter/:filter',
		on_partner_sign: '/nepal/acts/on_partner_sign',
		upload_payment_orders: '/nepal/acts/upload_payment_orders',
		upload_third_party_acts_and_invoices: '/nepal/acts/upload_third_party_acts_and_invoices',
		update_status: '/nepal/acts/:id/update_status',
		remark: '/nepal/acts/remark',
		protocol_generation_error: '/nepal/acts/:id/protocol_generation_error',
		annul_request: 'nepal/acts/annul_request',
	},
	survey: {
		base: '/exam/survey',
		question: '/exam/question',
		option: '/exam/option',
		attempt: '/exam/attempt',
		answer: '/exam/answer',
		download_results: '/exam/reports',
	},
	logs: {
		partner_events: '/partner_events',
		act_status_events: '/nepal/act_status_events',
		user_events: '/user_events',
		order_events: '/order_events',
		new_order_events: '/order_new_events',
		customer_identification_events: '/customer_identification_events',
		report_events: '/report_events',
		rbidos_request_events: '/rbidos_request_events',
		status_events: '/sber_mq/status_events',
		sbercrm_events: '/sber_mq/sbercrm_events',
		sms_rule_events: '/sms_rule_events',
		knowledge_events: '/knowledge/event',
		change_status_error_events: '/sber_mq/change_status_error_events',
		order_kes: '/sber_mq/order/:id/logs',
		bg_events: 'bg/event',
		bg_events_ast: '/bg/events/ast',
		bg_events_request_status: '/bg/events/request_status',
		online_orders: '/sber_mq/paperless_request/logs',
		reserve_accounts: '/sber_mq/reserve_accounts/logs',
		orders_api: '/sber_mq/api_request/create_task_external_request',
		qa_requests: '/qa/callback/external_requests',
		api_request_status: '/sber_mq/product_order_relation_api_request',
		resend_by_external_request_id: '/sber_mq/api_request/resend_by_external_request_id',
		integration_channel: '/sber_mq/rbidos_integration_channels/external_requests',
		external_requests: '/call_easy/call_requests/external_requests',
		department_events: '/department_events',
		cm: '/sber_mq/reserve_accounts/cm_logs',
		bprofile: '/sber_mq/api_request/agreements_external_request',
		blank_registration_date: '/sber_mq/events/order/blank_registration_date',
	},
	auth: {
		login: '/login',
		reset_password: '/login/reset_password',
		reset_password_by_token: '/login/reset_password_by_token',
		loginAs: '/user/:userId/login_as',
		updateAuthorizationData: '/user/:id/update_authorization_data',
		refresh_password: '/user/refresh_password',
		check_user: '/partner/payment',
	},
	notification: {
		template: '/notification_templates',
	},
	pop_up: {
		index: '/pop_up',
		partner_access_periods: '/exam/dictionaries',
	},
	blockProductGroup: {
		index: '/sber_mq/block_product_group',
	},
	packageOkved: {
		index: '/okved_package',
	},
	statistics: {
		create: '/statistics',
	},
	broker: {
		index: '/bg/request',
		full_data: '/bg/request/:id/full_request_data',
		create_commercial_order: '/bg/request/:id/create_commercial_autoorder',
		check_limit: '/bg/request/:id/check_limit',
		confirmation: '/bg/request/:id/confirmation',
		paper_lead: '/bg/request/:id/paper_lead',
		digital_lead: '/bg/request/:id/digital_lead',
		check_status: '/bg/request/:id/check_status',
		document: '/bg/document/:id',
		send_document: '/bg/request/:id/send_:type',
		save_document: '/bg/request/:id/document',
		save_limit_request_document: '/bg/limit_request/:request_id/document',
		post_request: '/bg/request/:id/post_request',
		update_request: '/bg/request/:id/update_request',
		bg_active: 'lead/bg_active/:inn',
		dependent_fields: '/bg/dict/dependent_fields',
		build: '/bg/request/build',
		build_commercial: '/bg/request/build_commercial',
		current_elements: '/bg/request/:id/current_elements',
		dict: '/bg/dict',
		calculate_commission: '/bg/request/:id/calculate_commission',
		commission: '/bg/requests/commission',
		get_bank_data: '/bg/request/:id/get_bank_data',
		support_info: '/bg/request/:id/support_info',
		change_lead: '/bg/request/:id/change_lead',
		save_new_send_address: '/bg/request/:id/save_new_send_address',
		download_trust_document: '/bg/request/:request_id/sign_trust_document/:id/:filename',
		black_list: '/bg/black_list',
		limit_request: '/bg/limit_request',
		limit_request_support_info: '/bg/limit_request/:id/support_info',
		limit_request_check_limit: '/bg/limit_request/:id/check_limit',
		limit_request_post_limit: '/bg/limit_request/:id/post_limit_request',
		limit_request_update_limit: '/bg/limit_request/:id/update_limit_request',
		limit_request_save_limit: '/bg/limit_request/:id',
		limit_request_check_status: '/bg/limit_request/:id/check_status',

		limit_create_digital_lead: '/bg/lead/create_digital_lead',
		limit_create_paper_lead: '/bg/lead/create_paper_lead',
		limit_confirmation: '/bg/lead/confirmation',
		limit_change_lead: '/bg/limit_request/:id/change_lead',
		calendar: 'dashboard/holiday',
		rework: '/bg/request/:id/rework',
		assign_request: '/bg/request/:id/assign',
		get_client_limit: '/bg/get_client_limit',
		get_client_limit_support_info: '/bg/get_client_limit/:inn/support_info',

		settings: {
			trust: '/bg/sign_trust_document',
		},
		favorite: '/bg/request/:id/favorite',

		svetofor_check: '/bg/svetofor_check/:inn',
		send_released_docs: '/bg/request/:id/send_released_docs',
		publications: {
			index: '/bg/publications',
		},
	},
	fake_responses: {
		dadata_suggest_by_id_party: 'fake_responses/dadata_suggest_by_id_party',
	},
	drs_fake_responses: {
		dadata_suggest_drs: 'fake_responses/reserve_accounts',
	},
	kr_drs_fake_responses: {
		rbidos_load_company: '/fake_responses/rbidos_load_company',
	},
	rbidos_load_company: {
		dadata_suggest_kr_drs: '/fake_responses/rbidos_load_company',
	},
	modal: {
		feedback: '/feedback',
	},
	agreement: {
		index: '/agreement',
		description: '/agreement/:id',
		by_key: '/agreement/by_key/:parent_type/:kind',
	},
	department: {
		index: '/department',
		show: '/department/:id',
		mass_create: '/department/mass_create',
	},
	merchant_status: {
		index: '/sber_mq/merchant_status_mappings',
		show: '/sber_mq/merchant_status_mappings/:id',
		productOrderStatuses: '/sber_mq/product_order_status',
	},
	partnerRequest: {
		index: '/partner_requests',
		show: '/partner_requests/:id',
		upload_file: '/partner_request_order_agreements/:id/files',
		set_status: '/partner_requests/:id/set_status/:status',
		resume: '/partner_requests/:id/resume',
		set_status_agremeent: '/partner_request_order_agreements/:id/set_status/:status',
		upload_file_agreements: '/partner_request_order_agreements/:id/files',
		fields_request: '/partner_requests/fields',
		agent_comment: '/partner_requests/:id/agent_comment',
		tmpp_comment: '/partner_requests/:id/tmpp_comment',
		delete_file_agreements: '/partner_request_order_agreements/:id/files',
		partner_request_infotecs_files: '/partner_requests/:id/infotecs_file',
		partner_request_delete_infotecs_files: '/partner_request_infotecs_files/:id',
		partner_request_set_status_infotecs_files:
			'/partner_request_infotecs_files/:id/set_status/:status',
		create_order_agreement_comment: '/partner_request_order_agreement_comments',
		update_order_agreement_comment: '/partner_request_order_agreement_comments/:id',
	},
	blackListPartner: {
		index: '/black_list_partner',
		mass_create: '/black_list_partner/mass_create',
	},
	partner: {
		contract: {
			create: '/partner/:partner_id/document/:document_type',
			update: '/partner/:partner_id/document/:id',
			delete: '/partner/:partner_id/document/:id',
			tags: '/document_tags',
		},
		index: '/partner',
	},
	sberID: {
		uri: 'sberid/openid_connect/authorization_uri',
		callback: '/sberid/openid_connect/callback',
	},
	chat: {
		index: 'chats',
		session: '/uni_chat/create_token',
		settings: '/uni_chat/settings',
	},
	order_tasks: {
		index: '/order_tasks',
		complete: '/order_tasks/:id/complete',
		revert_complete: '/order_tasks/:id/revert_complete',
		stats: '/order_tasks/stats',
		training_showed: '/order_tasks/counters/training_showed',
		task_model_logo_clicked: '/order_tasks/counters/task_model_logo_clicked',
	},
	modules: {
		rating: {
			create: '/feedback/evaluations',
		},
		notifications: {
			index: '/notifications',
		},
		dicts: {
			index: '/dicts',
		},
		setting: {
			index: '/setting',
		},
		header_report: {
			index: '/reports/stats',
		},
		userSettings: {
			index: '/user_settings',
		},
		reports: {
			[TYPE_REPORT.COLISEUM_CALL_REQUESTS]: '/call_easy/reports/call_requests',
			[TYPE_REPORT.COLISEUM_BLOCKS]: 'call_easy/reports/blocks',
			[TYPE_REPORT.COLISEUM_BLACK_LISTS]: 'call_easy/reports/black_lists',
			[TYPE_REPORT.COLISEUM_STATISTICS]: 'call_easy/reports/call_request_statistics',
			[TYPE_REPORT.RBIDOS_REQUEST_STATISTICS]: 'reports/rbidos_request_statistics',
			[TYPE_REPORT.RBIDOS_REQUEST]: 'reports/rbidos_requests',
			[TYPE_REPORT.CLICK_THROUGH]: 'reports/click_through',
			[TYPE_REPORT.SMS]: 'reports/sms',
			[TYPE_REPORT.EVENTS_REPORTS]: 'reports/reports',
			[TYPE_REPORT.EVENTS_USERS]: 'reports/events_users',
			[TYPE_REPORT.EVENTS_ORDERS]: 'reports/events_orders',
			[TYPE_REPORT.STATISTICS_NEO]: 'reports/neo_statistics',
			[TYPE_REPORT.EVENTS_NEW_ORDERS]: 'sber_mq/reports/events_orders',
			[TYPE_REPORT.EVENTS_PARTNERS]: 'reports/events_partners',
			[TYPE_REPORT.EVENTS_RBIDOS_REQUESTS]: 'reports/events_rbidos_requests',
			[TYPE_REPORT.EVENTS_CUSTOMER_IDENTIFICATIONS]: 'reports/events_customer_identifications',
			[TYPE_REPORT.EVENTS_UNBLOCK_REQUESTS]: '/sber_mq/reports/events_unblock_requests',
			[TYPE_REPORT.EVENTS_PRODUCTS]: 'sber_mq/reports/events_products',
			[TYPE_REPORT.STATISTICS]: '/reports/statistics',
			[TYPE_REPORT.NEPAL_ACTS]: '/nepal/reports/acts',
			[TYPE_REPORT.BG_REPORTS]: '/bg/reports/requests',
			[TYPE_REPORT.BG_REPORTS_EXTENDED]: '/bg/reports/extended_statistics',
			[TYPE_REPORT.SBER_CONFIRMATION]: '/nepal/reports/sber_confirmation',
			[TYPE_REPORT.BG_REQUEST_STATISTICS]: '/bg/reports/request_statistics',
			[TYPE_REPORT.PARTNER_REQUEST]: '/reports/partner_requests',
			[TYPE_REPORT.SDEX_LOGS]: 'reports/sber_big_data_logs',
			[TYPE_REPORT.PARTNER_CONTRACTS]: '/reports/partner_contracts',
			[TYPE_REPORT.PARTNERS_REGISTRY]: '/reports/partners_registry',

			[TYPE_REPORT.DEPARTMENTS]: '/reports/departments',
			[TYPE_REPORT.ORDER_TASKS_LOGS]: 'reports/task_model',
			[TYPE_REPORT.CREATIVE_PAYMENTS]: 'ord/reports/creative_payments',
			[TYPE_REPORT.BULK_CREATION]: 'partner_requests/mass_create/',
			[TYPE_REPORT.USERS_API]: 'reports/users_api',
			[TYPE_REPORT.SELF_EMPLOYED_LOGS]: 'sber_mq/reports/self_employed_logs',
			[TYPE_REPORT.SBER_DEPARTMENTS]: 'reports/sber_departments',
			[TYPE_REPORT.CALL_EASY_NEW_REGISTRATION]: 'reports/call_easy_new_registration',
			[TYPE_REPORT.SEARCH_CLIENT]: 'reports/search_client',
			[TYPE_REPORT.BLACK_LIST_PARTNERS]: 'reports/black_list_partners',
			[TYPE_REPORT.INFOTECS_REQUESTS]: 'reports/infotecs_requests',
			[TYPE_REPORT.EVENTS_DEPARTMENTS]: 'reports/events_departments',
			[TYPE_REPORT.EVENTS_CUSTOMER_IDENTIFICATIONS_DOCUMENT_PREDICTIONS]:
				'reports/events_customer_identifications_document_predictions',
			[TYPE_REPORT.BG_CALCULATE_COMMISSION]: 'bg/reports/calculate_commission',
			[TYPE_REPORT.ADS_INVOICES]: 'ord/reports/ads_invoices',
			[TYPE_REPORT.ADS_CREATIVES]: 'ord/reports/ads_creatives',
			[TYPE_REPORT.ADS]: 'reports/ads',
			[TYPE_REPORT.CSAT_METRICS]: 'reports/csat_metrics',
			[TYPE_REPORT.OPEN_SOURCE_REQUESTS]: 'bg/reports/open_source_requests',
			[TYPE_REPORT.UNBLOCK_REQUESTS]: '/sber_mq/reports/unblock_requests',
			[TYPE_REPORT.BLANK_REGISTRATION_DATE_ORDERS]:
				'sber_mq/reports/events_order_blank_registration_date',
		},
	},
	landing: {
		index: '/landing',
	},
	archiveBroker: {
		order: '/order/:id',
		archive: '/order/archive',
		orderRefusalStatuses: '/order_refusal_statuses',
		orderStatus: '/order_status',
		report: '/reports/archive_orders',
		contactDetails: '/order/:id/contact_details',
	},
	partnerProfile: {
		partner_new: 'partner/new',
		lead: {
			index: '/lead',
			activate: '/lead/activate',
			validate: '/lead/validate',
			complete: '/lead/complete',
			incorporation_form: '/dicts/incorporation_form',
			refresh_sms: '/lead/refresh_sms',
			refresh_email: '/lead/refresh_email',
			recreate_email: '/lead/recreate',
		},
	},
	prelogin: {
		index: '/partner',
	},
	profileOrganization: {
		index: '/partner_profiles',
		show: '/partner_profiles/:id',
		partner: '/partner',
	},
	user: {
		index: '/user',
		lead: {
			recreate: '/lead/recreate',
			lead_type: '/user/:id/lead_type',
		},
		widget: {
			set_feedback: '/user/user_widgets/sber_feedback',
		},
	},
	bank_employees: {
		index: '/bank_employees',
		time_off: '/time_off',
		substitution_info: '/substitution_info',
		login_substitution: 'user/:id/login_as_substitution',
	},
	user_documents: {
		index: '/user/user_documents',
	},
	csat_feedback: {
		index: 'csat_feedback',
	},
	socket: {
		ticket: '/user/:id/ws_ticket',
	},
}
